/* eslint-disable */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const CertificateTab = () => {
  const { lang } = useTranslation('client')

  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <div style={{ marginTop: 30 }}>
            <div style={{ marginBottom: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                Conditions for Obtaining a Certificate of Attendance at a
                Training Course
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  4.1 Pre-Registration and Attendance Commitment:
                </span>{' '}
                Trainees are required to pre-register for the training course
                and commit to attending it.
              </Text>
              <Text size="lg">
                <span className="font-bold"> 4.2 Attendance Requirement:</span>{' '}
                Trainees must attend a minimum of 70% of the total training
                course time to be eligible for a certificate of attendance and
                CME hours.
              </Text>
            </div>

            <div style={{ marginTop: 30 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                Conditions for Trainees to Agree to Register Attendance at the
                Training Program
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  {' '}
                  5.1 Target Group Eligibility:
                </span>{' '}
                Trainees must belong to the target group for the training
                program, as it is specifically designed to meet their needs and
                requirements.
              </Text>
              <Text size="lg">
                <span className="font-bold"> 5.2 Commitment to Policies:</span>{' '}
                Trainees are obligated to thoroughly review and agree to the
                policies and conditions outlined in the electronic registration
                form before registering for the training program.
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  {' '}
                  5.3 Exclusion from Teaching Hours:
                </span>{' '}
                Trainees who register in a course not designated for the target
                group are not entitled to claim CME hours.
              </Text>
            </div>
          </div>
        ) : (
          <div style={{ marginBottom: 30 }}>
            <div style={{ marginBottom: 30 }} dir="rtl">
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                تدريبية دورة حضور شهادة على الحصول شروط
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  {' '}
                  4.1 الحضور والالتزام بالتسجيل المسبق:
                </span>{' '}
                يجب على المتدربين التسجيل المسبق للدورة التدريبية والالتزام
                بحضورها.
              </Text>
              <Text size="lg">
                <span className="font-bold"> 4.2 متطلبات الحضور:</span> يجب على
                المتدربين الحضور لنسبة لا تقل عن 70% من إجمالي وقت الدورة
                التدريبية ليكونوا مؤهلين لشهادة الحضور وساعات CME.
              </Text>
            </div>

            <div style={{ marginBottom: 30 }} dir="rtl">
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                التدريبي البرنامج في الحضور تسجيل على المتدربين موافقة شروط
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  {' '}
                  5.1 أهلية المجموعة المستهدفة:
                </span>{' '}
                يجب على المتدربين أن ينتموا إلى المجموعة المستهدفة للبرنامج
                التدريبي، حيث تم تصميمه بشكل خاص لتلبية احتياجاتهم ومتطلباتهم.
              </Text>
              <Text size="lg">
                <span className="font-bold"> 5.2 الالتزام بالسياسات:</span>{' '}
                يلتزم المتدربون بمراجعة والموافقة بدقة على السياسات والشروط
                الموضحة في نموذج التسجيل الإلكتروني قبل التسجيل في البرنامج
                التدريبي.
              </Text>
              <Text size="lg">
                <span className="font-bold">
                  {' '}
                  5.3 استبعاد من ساعات التدريس:
                </span>{' '}
                المتدربون الذين يسجلون في دورة غير مخصصة للمجموعة المستهدفة ليس
                لهم الحق في المطالبة بساعات CME.
              </Text>
            </div>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default CertificateTab
